<template>
  <div class="withrawalDetail" :style="flag?'background:#f4f5f8':'background:#fff'">
    <Tab title="提现详情" />
    <div v-if="flag" class="success" @click="flag=!flag">
      <div class="sinformation"> 
        <img src="/static/img/withdrawal_s.png" alt />
        <p>提现申请成功</p>
        <span>
          等待审核
          <br />具体状态请在「货款」-「账户明细」中查看
        </span>
      </div>
      <div class="sdetail">
        <div>
          <p>收款账户</p>
          <p>
            <img src alt />
            <span>招商银行(6523)</span>
          </p>
        </div>
        <div>
          <p>提现金额</p>
          <p>500.00元</p>
        </div>
      </div>
    </div>
    <div v-else class="fail"  @click="flag=!flag">
      <img src="/static/img/withdrawal_failure.png" alt />
      <p>提现申请失败</p>
      <span>请检查您的网络</span>
    </div>
    <button @click="handleBtn()">{{flag?'确定':'重新提现'}}</button>
  </div>
</template>

<script>
import Tab from "base/tab/tab";
export default {
  data() {
    return {
      flag: true, //true 提现成功；false 提现失败
    };
  },
  methods: {
    handleBtn(){
      if(this.flag){
        this.$router.push('/goods_payment');
      } else {
        this.$router.push('/withdrawal');
      }
    }
  },
  components: {
    Tab,
  },
};
</script>

<style lang="scss" scoped>
.withrawalDetail {
  padding-top: 100px;
  height: 100%;
  width: 100%;
  .success {
    width: 694px;
    height: 800px;
    background: url("/static/img/withdrawal_bg.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    margin: 28px auto;
    .sinformation {
      padding: 70px 0 142px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 196px;
        height: 196px;
        display: block;
        margin-bottom: 38px;
      }
      p {
        height: 50px;
        font-size: 36px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 50px;
      }
      span {
        height: 74px;
        font-size: 26px;
        color: rgba(153, 153, 153, 1);
        line-height: 37px;
        text-align: center;
      }
    }
    .sdetail {
      div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 52px;
        p {
          margin-bottom: 37px;
          &:nth-child(1) {
            height: 42px;
            font-size: 30px;
            color: rgba(58, 58, 58, 1);
            line-height: 42px;
          }
          &:nth-child(2) {
            height: 42px;
            font-size: 30px;
            color: rgba(153, 153, 153, 1);
            line-height: 42px;
            display: flex;
            align-items: center;
            img {
              width: 36px;
              height: 36px;
              display: flex;
            }
          }
        }
      }
    }
  }
  .fail {
    border-top: 1px solid #f4f5f8;
    padding-top: 99px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 196px;
      height: 196px;
      display: block;
      margin-bottom: 38px;
    }
    p {
      height: 50px;
      font-size: 36px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 50px;
      margin-bottom: 11px;
    }
    span {
      height: 37px;
      font-size: 26px;
      font-weight: 500;
      color: rgba(153, 153, 153, 1);
      line-height: 37px;
    }
  }
  button {
    width: 690px;
    height: 96px;
    background: rgba(232, 64, 49, 1);
    border-radius: 48px;
    font-size: 32px;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    position: absolute;
    bottom: 40px;
    margin: auto 30px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/withdrawal/withdrawalDetail.vue